import { View, Text, TextInput, StyleSheet, CheckBox, ImageBackground, Pressable, FlatList } from 'react-native'
import React, { useEffect, useState, createContext, useContext } from 'react';
import { useParams, Link, useNavigate } from "react-router-dom";
import { FaHamsa, FaAlignJustify, FaCopy, FaHeadSideCough, FaOpera, FaHourglassStart, FaCalendarDay, FaCalendarCheck, FaCar, FaClock, FaSave, FaHospitalUser, FaHistory, FaSyncAlt, FaWalking, FaUmbrellaBeach, FaUserAltSlash, FaRegWindowClose } from "react-icons/fa";
import { useGeolocated } from "react-geolocated";
import haversine from 'haversine';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ThemeContext } from '../context/ThemeContext.js';
import { format, differenceInCalendarDays, differenceInMinutes, fromUnixTime, isBefore, hoursToMinutes } from 'date-fns';

const Appt = () => {
  // console.log('Appt started');

  const apptsUrl = process.env.REACT_APP_APPTS_URL;
  // const apptsUrl = process.env.REACT_APP_DEV_URL;
  // Object Definitions
  const statBase = { last: '', val: null, locked: false, dist: 0 };
  var apptState = {
    // remiders are 3 state none:0,received:1,confirmed:2
    // stats are On:1/Off:0 toggle
    // last is an epoch integer date
    rem24: { statBase },
    remToday: { statBase },
    statEnRoute: { statBase },
    statDelayed: { statBase },
    statThere: { statBase },
    statWait: { statBase },
    statWith: { statBase },
    statComplete: { statBase },
    statNoShow: { statBase },
    histBlob: {}
  }

  const start = {
    latitude: 1.1,
    longitude: -1.1
  }
  const end = {
    latitude: 2.2,
    longitude: -2.2
  }
  // State Variables
  const [curNow, setNow] = useState(null);
  const [theDate, setTheDate] = useState();
  const [showList, setShowList] = useState(false);

  const [windowStart, setWindowStar] = useState(-60);
  function addGMT(date) {
    const tzoffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    const gmtDate = new Date(date.getTime() + tzoffset);
    return gmtDate;
  }
  const [apptAge, setApptAge] = useState(differenceInMinutes(theDate, new Date()));
  const [refreshInterval, setRefreshInterval] = useState(17000);
  const isToday = (apptDate) => differenceInCalendarDays(fromUnixTime(apptDate), new Date()) === 0;
  const isFuture = (apptDate) => isBefore(new Date(), fromUnixTime(apptDate));
  const isLocked = (statField) => window.location.pathname.startsWith('/work') && statField.locked;

  const { id } = useParams();  // const { id } = useParams();
  const [reciID, setRecID] = useState(id);
  const [appt, setAppt] = useState(null);
  const [apptUpdated, setApptUpdated] = useState({ last: null, val: 0, locked: false, dist: 0 });
  const [dura, setDura] = useState(1);
  const [brassPass, updPass] = useState();
  const [brassKey, updKey] = useState();
  const [brassOk, updBrassOk] = useState(false);
  const [rem24, setRem24] = useState({ last: null, val: 0, locked: false, dist: 0 });
  const [remDay, setRemDay] = useState({ last: null, val: 0, locked: false, dist: 0 });
  const [statRoute, setStatEnRoute] = useState({ last: null, val: 0, locked: false, dist: 0 });
  const [statDelay, setStatDelayed] = useState({ last: null, val: 0, locked: true, dist: 0 });
  const [statThere, setStatThere] = useState({ last: null, val: 0, locked: true, dist: 0 });
  const [statWait, setStatWait] = useState({ last: null, val: 0, locked: true, dist: 0 });
  const [statWith, setStatWith] = useState({ last: null, val: 0, locked: true, dist: 0 });
  const [statDone, setStatDone] = useState({ last: null, val: 0, locked: true, dist: 0 });
  const [statNoShow, setStatNoShow] = useState({ last: null, val: 0, locked: true, dist: 0 });
  const statStamp = (statVal) => ({ last: format(new Date().toLocaleString(), 'HH:mm'), val: ((statVal.val + 1) % 2) });
  const statGoodStyle = (statOjb, dis) => (dis ? styles.apptDis : statOjb.val === 1 ? styles.apptGood : styles.apptBase);
  const statWaitStyle = (statOjb, dis) => (dis ? styles.apptDis : statOjb.val === 1 ? styles.apptWaiting : styles.apptBase);
  const xGPS = (apptGPS) => {
    var newObj = { latitude: 0, longitude: 0 };
    try {
      newObj = {
        latitude: apptGPS === null ? 0 : JSON.parse(apptGPS).latitude ? JSON.parse(apptGPS).latitude : apptGPS.split(",")[1],
        longitude: apptGPS === null ? 0 : JSON.parse(apptGPS).longitude ? JSON.parse(apptGPS).longitude : apptGPS.split(",")[0]
      };
    } catch (e) {
    }
    return newObj;
  };

  function sortField(val) {
    if (Number.isNaN(val)) { return val.toLowerCase() } else { return val }
  }
  const [displaylist, setDisplay] = useState(null);

  const [updNote, onChangeNote] = useState('');
  const [noShow, onNoShow] = useState(false);

  const [stat1, setStat1] = useState(null);
  const [stat2, setStat2] = useState(null);
  const [stat3, setStat3] = useState(null);
  const [showFlash, setShowFlash] = useState(false);

  const { colorScheme, setColorScheme, theme } = useContext(ThemeContext);
  // console.log('ThemeContext', ThemeContext);
  // console.log('theme', theme);
  // console.log('colorScheme', colorScheme);
  const styles = createStyles(theme, colorScheme);
  const remSyles = [styles.apptBase, styles.apptWaiting, styles.apptGood];
  const normToggle = [styles.apptBase, styles.apptGood];
  const waitToggle = [styles.apptBase, styles.apptWaiting];

  // auto-refresh
  const refreshAppt = () => {
    // update time
    try {
      setNow(format(new Date().toLocaleString(), 'hh:mm'));
      // end stays constant and we change start with the GPS from the browser
      start.longitude = coords.longitude;
      start.latitude = coords.latitude;
    } catch (error) {

    }
  }

  // Control Appt state updates
  const updProgress = (buttonPressed) => {
    // if a state has already occured, there are only some situation were you can go back a step
    // we check and updat stat2
    try {
      var eventTime = format(new Date().toLocaleString(), 'HH:mm');
      refreshAppt();
      setStat1(buttonPressed);
      setStat2(eventTime);
      setApptUpdated({ val: 1 });
    } catch (error) {
      throw error;
    }
  }

  // Handles note changes
  const updApptNotes = (text) => {
    // Let them know the note has changed
    onChangeNote(text);
    setApptUpdated({ val: 1 });
  }

  // http://139.177.205.178:2095/scraperextracts
  // https://ctrl2.cherry2024.com:2096/getservers
  useEffect(() => {
    fetchMetrics(reciID);
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(refreshAppt, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  const fetchMetrics = (curReciID) => {
    // retrieve and then setData()
    // `https://dev.cherry2024.com:2096/getAppt?recid=${id}`
    //
    // console.log('fetchMetrics started');

    fetch(`${apptsUrl}getAppt?recid=${curReciID}`)
      .then(response => response.json())
      .then(data => {
        setAppt(data);
        data.map((rec, index) => (
          document.title = `${rec.atWhen.split('-')[0]}|${rec.apptClient}`,
          updKey(rec.occID),
          setDura(rec.apptHours ? parseInt(rec.apptHours) === 0 ? 1 : rec.apptHours : 1),
          console.log('dura', rec.apptHours),
          onChangeNote(rec.apptNotes),
          setTheDate(addGMT(fromUnixTime(rec.dateAppt))),
          yourList(rec.interpreter),
          setStatEnRoute(JSON.parse(rec.interState).statEnRoute),
          setStatDelayed(JSON.parse(rec.interState).statDelayed),
          setStatThere(JSON.parse(rec.interState).statThere),
          setStatWait(JSON.parse(rec.interState).statWait),
          setStatWith(JSON.parse(rec.interState).statWith || statBase),
          setStatDone(JSON.parse(rec.interState).statComplete),
          setStatNoShow(JSON.parse(rec.interState).statNoShow),
          JSON.parse(rec.interState).rem24 ? setRem24(JSON.parse(rec.interState).rem24) : setRem24({ last: '', val: 0 }),
          JSON.parse(rec.interState).remToday ? setRemDay(JSON.parse(rec.interState).remToday) : setRemDay({ last: '', val: 0 })
        ))
      })
      .catch(error => console.error(error));
  }

  const yourList = (talker) => {
    //
    // console.log('your list', talker, talker.replace(/ /g, '').toUpperCase());
    fetch(`${apptsUrl}scraperextracts?talker=${talker.replace(/ /g, '').toUpperCase()}`)
      .then(response => response.json())
      .then(data => {
        console.log('your data', data);
        const dataArr = [];
        var altoto = 0;
        var rem24toto = 0;
        var remDaytoto = 0;
        data.forEach((rec) => {
          dataArr.push(rec);
          altoto = altoto + rec.alCount;
          rem24toto = rem24toto + (rec.al24.val === 1 ? 1 : 0);
          remDaytoto = remDaytoto + (rec.alToday.val === 1 ? 1 : 0);
        });
        // setAlertTotal(altoto);
        // setTomTotal(rem24toto);
        // setDayTotal(remDaytoto);
        setDisplay(dataArr);
      })
      .catch(error => console.error(error));
  }


  const updAppt = (gps) => {
    var eventTime = format(new Date().toLocaleString(), 'HH:mm');
    updProgress("SAVED");
    setApptUpdated({ last: eventTime, val: 2 });
    // auto update the reminders
    if (rem24.val === 1 && statRoute && statRoute.val === 1) { rem24.val = 2 };
    if (remDay && remDay.val === 1 && statRoute && statRoute.val === 1) { remDay.val = 2 };
    // build the stat obj and stringify
    apptState.rem24 = rem24;
    apptState.remToday = remDay;
    apptState.statEnRoute = statRoute;
    apptState.statDelayed = statDelay;
    apptState.statThere = statThere;
    apptState.statWait = statWait;
    apptState.statWith = statWith;
    apptState.statComplete = statDone;
    apptState.statNoShow = statNoShow;
    updLocks(apptState);
    apptState.histBlob = "blob";
    var updcmd = `${apptsUrl}updAppt?recid=${id}&apptHours=${dura}&lastDist="${(coords.latitude)},${(coords.longitude)}"&interState='${JSON.stringify(apptState)}'`;
    if (updNote != null) {
      updcmd = updcmd + `&apptNotes=${encodeURIComponent(updNote)}`;
    }
    if (brassPass != null) {
      updcmd = updcmd + `&interpreter=${encodeURIComponent(brassPass)}`;
      updcmd = updcmd + `&occID=${encodeURIComponent(brassPass)}`;
      updcmd = updcmd + `&isLive=-3`;
    }
    console.log(updcmd);
    // Update the Appt
    fetch(updcmd)
      .then(response => response.json())
      .then(data => {
        // console.log(data);
      })
      .catch(error => console.error(error));
  }

  // Control Appt state updates
  const updLocks = (interState) => {
    // set locks on status buttons according to events completed
    setStat1(`Locking D:${interState.statComplete.last}  T:${interState.statThere.last}  R:${interState.statEnRoute.last}`);
    try {
      // see if we're done. Lock it all.
      if (interState.statComplete.last) {
        var cur24 = interState.rem24;
        cur24.locked = true;
        setRem24(cur24);
        var curDay = interState.remToday;
        curDay.locked = true;
        setRemDay(curDay);
        var curRoute = interState.statEnRoute;
        curRoute.locked = true;
        setStatEnRoute(curRoute);
        var curDelay = interState.statDelayed;
        curDelay.locked = true;
        setStatDelayed(curDelay);
        var curThere = interState.statThere;
        curThere.locked = true;
        setStatThere(curThere);
        var curWait = interState.statWait;
        curWait.locked = true;
        setStatWait(curWait);
        var curWith = interState.statWith;
        curWith.locked = true;
        setStatWith(curWith);
        var curNoShow = interState.statNoShow;
        curNoShow.locked = true;
        setStatNoShow(curNoShow);
        var curDone = interState.statComplete;
        curDone.locked = true;
        setStatDone(curDone);
        setStat1("Locked by Done");

        return;
      }
      // see if there has happened
      if (interState.statThere.last) {
        var curThere = interState.statThere;
        curThere.locked = true;
        setStatEnRoute(curThere);
        var curDelay = interState.statDelayed;
        curDelay.locked = true;
        setStatDelayed(curDelay);
        // unlock Wait With Done NoShow
        var curWait = interState.statWait;
        curWait.locked = false;
        setStatWait(curWait);
        var curWith = interState.statWith;
        curWith.locked = false;
        setStatWith(curWith);
        var curNoShow = interState.statNoShow;
        curNoShow.locked = false;
        setStatNoShow(curNoShow);
        var curDone = interState.statComplete;
        curDone.locked = false;
        setStatDone(curDone);
        setStat1("Locked by There");

        return;
      }
      // see if en route has happened
      if (interState.statEnRoute.last) {
        var curRoute = interState.statEnRoute;
        curRoute.locked = true;
        setStatEnRoute(curRoute);
        // unlock Delay and There
        var curDelay = interState.statDelayed;
        curDelay.locked = false;
        setStatDelayed(curDelay);
        var curThere = interState.statThere;
        curThere.locked = false;
        setStatThere(curThere);
        setStat1("Locked by En Route");
      }
    } catch (error) {
      throw error;
    }
  }

  const checkBrass = () => {
    var eventTime = format(new Date().toLocaleString(), 'HH:mm');
    updProgress("Authenicating");
    setApptUpdated({ last: eventTime, val: 2 });
    if (brassKey === brassPass) {
      updProgress("Welcome");
      updBrassOk(true);
    } else {
      updProgress("Password does not match");
    }
  }

  const copyAppt = async (appt) => {
    try {
      var toPaste = appt.apptClient + "\n" + appt.onDate + " " + appt.atWhen + "\n" + appt.apptLoc + "\n" + appt.apptAddr + "\n";
      await navigator.clipboard.writeText(toPaste);
      setShowFlash(true);
      setTimeout(() => setShowFlash(false), 3000); // Hide after 3 seconds
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }

  const copyOther = async (copySource) => {
    try {
      var toPaste = copySource + "\n";
      await navigator.clipboard.writeText(toPaste);
      setShowFlash(true);
      setTimeout(() => setShowFlash(false), 3000); // Hide after 3 seconds
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 15000,
      isOptimisticGeolocationEnabled: false,
    });

  return (
    <div className="border border-end border-start border-warning">
      {appt ?
        <div>
          {appt.map((rec, index) => (
            <div key={rec.recid} className="container-fluid">
              <div className="row">
                <Offcanvas show={showList} className="mt-2" data-bs-theme="dark" placement='bottom' style={{ height: '70vh' }}>
                  <Offcanvas.Header className="sidebarright">
                    <Offcanvas.Title>{rec.interpreter} Yours</Offcanvas.Title>
                    <Button variant="secondary" style={styles.apptBase} title='YOURS' onClick={() => yourList(rec.interpreter)}><FaSyncAlt /></Button>
                    <button className="btn btn-sm btn-outline-warning" onClick={() => setShowList(false)}>Close</button>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Stack>
                      {displaylist &&
                        displaylist
                          .sort((a, b) =>
                          (sortField(a['dateAppt']) > sortField(b['dateAppt']) ? 1 :
                            ((sortField(b['dateAppt']) > sortField(a['dateAppt'])) ? -1 : 0)))
                          .filter(appt => (appt.ageDays <= 0))
                          .map((item, index) => (
                            <View key={item.id} style={[styles.yoursView]}>
                              <Text style={item.ageHours > 0 ? styles.yoursName : styles.yoursNameFuture} >{item.apptClient}
                              </Text>
                              <Text style={styles.yoursText}>
                                {format(item.onDate, 'EEEEEE do')}&nbsp;&nbsp;&nbsp;
                                <br></br>{item.atWhen.split('-')[0]}
                              </Text>
                              <Button variant="secondary" style={styles.yoursButton} title='GO TO THIS APPT' onClick={() => [setRecID(item.recid), fetchMetrics(item.recid), setShowList(false)]}><FaHamsa /></Button>
                              <Stack style={{ flex: '1' }}>
                                {item.alEnRoute !== 0 && <FaCar style={styles.yourFail} />}
                                {item.alThere !== 0 && <FaHospitalUser style={styles.yourFail} />}
                                {item.alPatient !== 0 && item.alPatient && <FaHeadSideCough style={styles.yourFail} />}
                                {item.alDone !== 0 && <FaUmbrellaBeach style={styles.yourFail} />}
                              </Stack>
                            </View>
                          ))}
                    </Stack>
                  </Offcanvas.Body>
                </Offcanvas>

                <Offcanvas show={rec.isLive === -3 && !brassOk} className="mt-2" data-bs-theme="dark">
                  <Offcanvas.Header className="sidebarright">
                    <Offcanvas.Title><FaOpera style={{ color: "darkgoldenrod" }} />&nbsp;Cherry2024 Brass Ring</Offcanvas.Title>
                    <button className="btn btn-sm btn-outline-warning" onClick={() => window.close()}>Close</button>
                  </Offcanvas.Header>
                  <Offcanvas.Body style={styles.text}>
                    <Stack className="sidebarright" gap={3}>
                      <div className="p-2 rowodd row-fluid">
                        <Text style={styles.text} >{rec.interpreter}, please provide the password that was used to lock this appointment.</Text>
                      </div>
                      <span className="d-flex  align-items-center justify-content-center ">
                        <TextInput
                          style={styles.updBrass}
                          onChangeText={updPass}
                          value={brassPass}
                          placeholder="Password"
                          keyboardType="default"
                        />
                      </span>
                      <div className="p-2 roweven row-fluid">
                        <button title="Open Appointment" onClick={() => [checkBrass()]}>Open</button>
                        <hr></hr>
                      </div>
                    </Stack>
                  </Offcanvas.Body>
                </Offcanvas>
                <span className="col-sm-3 d-flex  align-items-center justify-content-center ">
                  Client:
                  <h3 style={styles.title}>{rec.apptClient}</h3>
                  {rec.isRush === 'On'
                    ? <Text style={styles.rush} >RUSH</Text>
                    : <Text>&nbsp;</Text>
                  }&nbsp;&nbsp;
                  <div >
                    <Text style={styles.time}>{curNow}</Text>
                    <br></br>
                    <Button variant="secondary" style={styles.apptBase} title='YOURS' onClick={() => setShowList(true)}><FaAlignJustify /></Button>
                  </div>
                </span>
                <span className="col-sm-3 d-flex  align-items-center justify-content-center ">
                  <h5>{rec.apptLoc}&nbsp;&nbsp;<a target='_blank'
                    rel='noopener noreferrer' href={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(rec.apptAddr)}>Show&nbsp;Map</a></h5>
                </span>
                <span className="col-sm-3 d-flex  align-items-center justify-content-center ">
                  <h5>
                    {rec.apptAddr}
                  </h5>
                </span>
                <span className="col-sm-3 d-flex  align-items-center justify-content-center">
                  <h3 style={styles.title}>{rec.onDate}<br></br>{rec.atWhen}</h3>
                  <button style={{ color: "green" }} className="btn btn-sm btn-outline-success" title="COPY APPOINTMENT DATE and TIME" onClick={() => copyOther(rec.onDate + " " + rec.atWhen)}><FaCopy /></button>
                  <Button variant="secondary" style={remSyles[apptUpdated.val]} title='REFRESH' onClick={() => window.location.reload()}><FaSyncAlt /></Button>
                </span>
              </div>
              {rec.isLive === -2 ?
                <Text style={styles.title}>
                  <h1> <FaOpera className="runningman" />&nbsp; &nbsp;Brass Ring&nbsp; &nbsp;</h1>
                  <h3>You lucky sod. The first one to grab the Brass Ring gets it so Reaction Time is a Factor.</h3>
                  <div className="row">
                    <span className="align-items-center justify-content-start ">
                      <br></br>
                      <Button style={remSyles[apptUpdated.val]} onClick={() => [updAppt()]}> <FaOpera className="runningman" />&nbsp;UPDATE <FaOpera className="runningman" />&nbsp;{apptUpdated.last}</Button>
                    </span>
                    <span className="d-flex  align-items-center justify-content-center ">
                      <TextInput
                        style={styles.updBrass}
                        onChangeText={updPass}
                        value={brassPass}
                        placeholder="Enter you Name. It will be used as the password."
                        keyboardType="default"
                      />
                    </span>
                  </div>
                  <hr></hr>
                  <p className='detailtxt'>Enter your Name. Then press the Update button to try for the Appt.</p>
                  <p className='detailtxt'>Normally, you get an Appt sent to you and there is no password. This is different. You are claiming the Brass Ring. To keep it, grab it before anyone else does and you lock it away. To lock it, you gotta set your name as the password.</p>
                  <hr></hr>
                  <p className='App-list'>
                    If you are first, you are now the only Interpreter that can change it.
                  </p>
                  <p className='App-list'>This is a computer, it is stupid. The only way you get the Brass Ring is to enter the note PERFECTLY. </p>
                  <hr></hr>
                  <p className='App-list'>Perfect is Your Name (First Last). Yes, put a space between your first and last name.</p>
                  <hr></hr>
                  <p className='App-list'>If you are first, the Appt will be assigned to you. You can check the Appt in 5 minutes and if your name is on it and your name unlocks it, it is now your appointment.</p>
                </Text>
                : rec.isLive === -1 ? (
                  <Text style={styles.noGeo}>
                    <h1>This Appointment is Inactive.</h1>
                    <h3>Updates are no longer allowed.</h3>
                  </Text>
                ) : (!isToday(rec.dateAppt) && !isFuture(rec.dateAppt) && window.location.pathname.startsWith('/work')) ? (
                  <Text style={styles.notYet}>
                    <h2>Appointment done.</h2>
                  </Text>
                ) : !isGeolocationAvailable ? (
                  <Text style={styles.noGeo}>
                    <h1>ERROR</h1>
                    <h1>Your browser does not support Geolocation. Geolocation is required to update the Appt.</h1>
                  </Text>
                ) : !isGeolocationEnabled ? (
                  <Text style={styles.noGeo}>
                    <h1>ERROR</h1>
                    <h1>Geolocation is not enabled.  Geolocation is required to update the Appt. Please go into your Browser settings and enable Location.</h1>
                  </Text>
                ) : coords ? (
                  <div className="container">
                    <div className="row">
                      <span className="col-sm-12 d-flex  align-items-top justify-content-right ">
                        <Stack gap={3}>
                          <span>Hrs:&nbsp;
                            <Button style={styles.duramicro} onClick={() => [updProgress("Hours to 1"), setDura(1)]} title='Duration To 1'><FaHourglassStart /></Button>
                            <br></br>
                                    <Button style={styles.dura} onClick={() => [updProgress("Hours"), setDura((dura % 12.5) + 0.25)]} title='Duration'><b>{Math.floor(dura)}</b>h&nbsp;<b>{hoursToMinutes(dura % 1)}</b>m</Button>
                            &nbsp;&nbsp;&nbsp;<button style={{ color: "green" }} className="btn btn-sm btn-outline-success" title="COPY APPOINTMENT TEXT" onClick={() => copyAppt(rec)}><FaCopy /></button>
                            {showFlash && <div className={`flash ${!showFlash ? 'hide' : ''}`}>Appointment text COPIED. Ready to Paste.</div>}
                          </span>
                          <Text style={styles.sectionTitle}>Reminders</Text>
                          <Button disabled={rem24.locked} variant="success" style={remSyles[rem24 ? rem24.val : 0]} onClick={() => [updProgress("24hr"), setRem24({ last: format(new Date().toLocaleString(), 'HH:mm'), val: 2 })]}>24H <FaCalendarCheck className="runningman" /></Button>
                          <Button disabled={remDay.locked} variant="success" style={remSyles[remDay ? remDay.val : 0]} onClick={() => [updProgress("Today"), setRemDay({ last: format(new Date().toLocaleString(), 'HH:mm'), val: 2 })]}>Today <FaCalendarDay className="runningman" /></Button>
                          <Text style={styles.sectionTitle}>Send</Text>
                          <Button style={remSyles[apptUpdated.val]} variant="success" onClick={() => [updAppt(rec.apptGPS)]}>UPDATE<br></br><FaSave />&nbsp;{apptUpdated.last}</Button>
                        </Stack>
                        <Stack gap={1}>
                          <Text style={styles.sectionTitle}>Interpreter Status</Text>
                          <Button disabled={isLocked(statRoute)} variant="success" style={statGoodStyle(statRoute, statRoute.locked)} onClick={() => [updProgress("EnRoute"), setStatEnRoute(statStamp(statRoute))]}>En Route <FaCar className="runningman" />&nbsp;{statRoute.last}</Button>
                          <Button disabled={isLocked(statDelay)} variant="error" style={statWaitStyle(statDelay, statDelay.locked)} onClick={() => [updProgress("Delayed"), setStatDelayed(statStamp(statDelay))]}>Delayed <FaClock className="runningman" />&nbsp;{statDelay.last}</Button>
                          <Text style={styles.sectionTitle}>Appt Begins</Text>
                          <Button disabled={isLocked(statThere)} variant="success" style={statGoodStyle(statThere, statThere.locked)} onClick={() => [updProgress("There"), setStatThere(statStamp(statThere))]}>Arrived <FaHospitalUser className="runningman" />&nbsp;{statThere.last}</Button>
                          <Text style={styles.sectionTitle}>Patient Status</Text>
                          <Button disabled={isLocked(statWait)} variant="error" style={statWaitStyle(statWait, statWait.locked)} onClick={() => [updProgress("Waiting"), setStatWait(statStamp(statWait))]}>Late <FaHistory className="runningman" />&nbsp;{statWait.last}</Button>
                          <Button disabled={isLocked(statWith)} variant="success" style={statGoodStyle(statWith, statWith.locked)} onClick={() => [updProgress("Patient"), setStatWith(statStamp(statWith))]}>Here <FaHeadSideCough className="runningman" />&nbsp;{statWith.last}</Button>
                          <Button disabled={isLocked(statNoShow)} variant="error" style={statWaitStyle(statNoShow, statNoShow.locked)} onClick={() => [updProgress("NoShow"), setStatNoShow(statStamp(statNoShow))]}>No Show <FaUserAltSlash className="runningman" />&nbsp;{statNoShow.last}</Button>
                          <Text style={styles.sectionTitle}>Complete</Text>
                          <Button disabled={isLocked(statDone)} variant="success" style={statGoodStyle(statDone, statDone.locked)} onClick={() => [updProgress("Completed"), setStatDone(statStamp(statDone))]}>Done <FaWalking className="runningman" /><FaUmbrellaBeach className="runningman" />&nbsp;{statDone.last}</Button>
                        </Stack>
                      </span>
                    </div>
                    <div className="row">
                      <span className="d-flex  align-items-center justify-content-center ">
                        {(statDone.val === 1 || statDelay.val === 1 || statWait.val === 1 || statNoShow.val === 1) &&
                          <TextInput
                            style={styles.updNote}
                            onChangeText={updApptNotes}
                            value={updNote}
                            placeholder="Update Notes are REQUIRED for No Show"
                            keyboardType="default"
                            multiline="true"
                          />
                        }
                      </span>
                    </div>
                    <div className="row">
                      <span className="col-sm-3 d-flex  align-items-center justify-content-center ">
                        Status:&nbsp;&nbsp;
                        <Text style={styles.title}>{rec.apptState}</Text>
                        &nbsp;&nbsp;
                        {rec.isRush === 'On' && <Text style={styles.rush} >&nbsp;RUSH&nbsp;</Text>}
                      </span>
                      <span className="col-sm-4 d-flex  align-items-center justify-content-center ">
                        {(stat1) &&
                          <p>
                            Last&nbsp;Action:&nbsp;{stat1}&nbsp;{stat2}
                          </p>
                        }
                        <p className="padit">
                          {rec.interpreter} for {rec.farmOrg} speaking {rec.clientLanguage}
                        </p>
                        <Button variant="success" style={remSyles[apptUpdated.val]} title='CLOSE' onClick={() => window.close()}><FaRegWindowClose /></Button>
                      </span>
                      <span className="col-sm-3 d-flex ">
                        {coords ? <div>
                          Your Position
                          <div>Longitude:&nbsp;{coords.longitude}&nbsp;</div>
                          <div>Latitude:&nbsp;{coords.latitude}&nbsp;</div>
                        </div>
                          : <br></br>
                        }
                      </span>
                    </div>
                  </div>
                ) : (
                  <div>Getting the location data&hellip; </div>
                )}
            </div>

          ))
          }
          <div className="container">
            <hr></hr>
            <div className="row">
              <h4>You are here to work an Appointment {appt.isLive}
                {appt && appt.isLive < 0 ? <span>.... Well.... not this one.</span> : <span>.</span>}
              </h4>
              <ul>
                <li>Browser Location service must be enabled.</li>
                <li>As you work the appt, you use this page to update how things are going</li>
                <li>You Change the Status of the Appt by pressing a button in the right column.</li>
              </ul>
              <div>
                <h4>You Change the Status of the Appt</h4>
                <p>
                  These are the various updates you would make according to how things are going.
                </p>
                <ul>
                  <li>"En Route" </li>
                  <li>"Delayed" </li>
                  <li>"At Appointment" </li>
                  <li>"Waiting for Client" </li>
                  <li>"With Client" </li>
                  <li>"No Show" </li>
                  <li>"Appointment Completed" </li>
                </ul>
              </div>
              <h4>You have a Map button that opens the Google Maps for the Appt Location.</h4>
              <ul>
                <li>You can Track your Location using the Map.</li>
              </ul>
              <h4>The basic flow is to make a change and then press the Update button.</h4>
              <ul>
                <li>Yellow buttons indicate a reminder that needs attemtion or dangerous situation where you might lose your updates.</li>
                <li>If you change a status, add/change the Note, update the hours, the Update and Refresh and Close button all go yellow. If you don't Update, you will lose the changes you made.</li>
                <li>If a Reminder is yellow, press on it and it should turn green. Then Update to acknowledge the Reminder to the Admins.</li>
                <li>Press on the blue Hours button to add 15 minutes to the appointment. Then Update to save the new hours. </li>
                <li>Press on the blue hourglass to set the hours back to 1.</li>
                <li>Here are the icons and their meaning:<br></br>
                  <FaRegWindowClose className="runningman" />=Close. CHANGES CAN BE LOST<br></br>
                  <FaSyncAlt className="runningman" />=Refresh the page. CHANGES CAN BE LOST<br></br>
                  <FaCalendarDay className="runningman" />=24 Hour Reminder.<br></br>
                  <FaCalendarCheck className="runningman" />=Today Reminder.<br></br>
                  <FaCar className="runningman" />=You are EnRoute to the appointment.<br></br>
                  <FaClock className="runningman" />=They was a Delay before arrival.<br></br>
                  <FaHospitalUser className="runningman" />=Arrived at Appointment. Interpreter is There.<br></br>
                  <FaHistory className="runningman" />=Waiting for Patient.<br></br>
                  <FaHeadSideCough className="runningman" />=With Patient.<br></br>
                  <FaUserAltSlash className="runningman" />=No Show.<br></br>
                  <FaWalking className="runningman" /><FaUmbrellaBeach className="runningman" />=Done.<br></br>
                </li>
              </ul>

            </div>
            <div>
              <h4><FaOpera />&nbsp;Brass Ring&nbsp;<FaOpera /></h4>
              <ul>
                <li>This is a chance to grab an Appointment.<br></br>
                  Hurry Up. If you are not the only person to get this Brass Ring, your competitor could be getting it Right Now!
                </li>
                <li>Enter your name and hit the "Update" button.<br></br>
                  Remember it, you'll need it to unlock the Appointment. If you forget it, you have to contact the Admin.
                </li>
              </ul>
            </div>
          </div>
        </div >

        : <div className="detailtxt"><h3>Loading Appointment...</h3></div>}
    </div >
  );
};

export default Appt;


function createStyles(theme, colorScheme) {
  return StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'column',
      backgroundColor: 'black',
      // backgroundColor: theme.background,
    },

    text: {
      // color: theme.rowtext,
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: '#202',
      flex: 2,
    },
    textthin: {
      //      color: theme.rowtext,
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: '#202',
      flex: 1,
    },
    text1: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: '#202',
      flex: 2,
    },
    time: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'right',
    },


    sectionTitle: {
      // color: theme.text,
      textAlign: 'left',
      marginLeft: '13px',
      marginRight: '18px',
      color: 'lightgray',
      fontSize: '1em',
      fontWeight: 'bold',
      // backgroundColor: theme.rowbg,
      // backgroundColor: '#202',
      backgroundImage: 'linear-gradient(to right, rgba(255, 0, 0, 0), rgba(57, 0, 83, 0.99))',
    },

    text1thin: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: '#202',
      flex: 1,
    },
    nametext: {
      color: 'gold',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: '#202',
      flex: 2,
    },
    rush: {
      color: 'red',
      fontSize: '3em',
      textAlign: 'center',
      // backgroundColor: theme.background,
      backgroundColor: 'white',
    },
    title: {
      // color: theme.header,
      color: 'chocolate',
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.background,
      backgroundColor: 'black',
      width: "90%"
    },
    distance: {
      // color: theme.header,
      color: 'chocolate',
      fontSize: '1.5em',
      fontWeight: 'bold',
      height: "45px",
      //textAlign: 'left',
      // backgroundColor: theme.background,
      backgroundColor: 'black'
    },
    updNote: {
      // color: theme.header,
      textAlignVertical: "top",
      marginTop: "5px",
      borderRadius: 5,
      padding: "3px",
      color: 'black',
      fontSize: '1.3em',
      height: 100,
      textAlign: 'left',
      width: "80%",
      // backgroundColor: theme.background,
      backgroundColor: 'lightgray'
    },
    updBrass: {
      // color: theme.header,
      textAlignVertical: "top",
      marginTop: "1px",
      borderRadius: 5,
      padding: "3px",
      color: 'black',
      fontSize: '1.1em',
      height: 40,
      textAlign: 'left',
      width: "80%",
      // backgroundColor: theme.background,
      backgroundColor: 'lightgray'
    },
    apptButon: {
      marginLeft: "15px",
      marginRight: "15px",
    },
    apptBase: {
      backgroundColor: 'transparent',
      color: 'chocolate',
      marginLeft: "20px",
      marginRight: "20px",
      backgroundImage: 'linear-gradient(to right, rgba(255, 0, 0, 0), rgba(57, 0, 83, 0.99))',

    },
    apptDis: {
      backgroundColor: 'gray',
      color: 'aliceblue',
      marginLeft: "20px",
      marginRight: "20px",
    },
    apptWaiting: {
      backgroundColor: 'gold',
      color: 'black',
      marginLeft: "15px",
      marginRight: "15px",
    },
    apptGood: {
      backgroundColor: 'green',
      marginLeft: "10px",
      marginRight: "10px",
    },
    dura: {
      color: "white",
      fontSize: '1.2em',
      backgroundColor: 'black',
      backgroundImage: 'linear-gradient(to right, rgba(38, 0, 255, 0), rgba(0, 1, 83, 0.99))',
      borderColor: "gold",
      padding: '5px',
    },
    duramicro: {
      color: "gold",
      fontSize: '0.8em',
      backgroundColor: 'black',
      backgroundImage: 'linear-gradient(to right, rgba(38, 0, 255, 0), rgba(0, 1, 83, 0.99))',
      borderColor: "gold"
    },

    noGeo: {
      color: "red",
      fontSize: '3em',
      backgroundColor: 'yellow',

    },

    yoursView: {
      color: "white",
      fontSize: '1em',
      backgroundColor: 'black',
      backgroundImage: 'linear-gradient(to right, rgba(38, 0, 255, 0), rgba(0, 1, 83, 0.99))',
      paddingLeft: '4px',
      borderLeftWidth: "2px",
      borderLeftColor: "whitesmoke",
      marginBottom: "0.2em",
      flexDirection: 'row',
    },

    yoursName: {
      color: "goldenrod",
      fontSize: '1.2em',
      flex: '8',
    },
    yoursNameFuture: {
      color: "white",
      fontSize: '1.2em',
      flex: '8',
    },
    yoursNamePast: {
      display: 'none',
    },
    yoursText: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.2em',
      fontWeight: 'bold',
      // textAlign: 'right',
      flex: '4',
    },
    yoursButton: {
      // color: theme.text,
      color: 'goldenrod',
      fontSize: '1.2em',
      backgroundColor: 'black',
      backgroundImage: 'linear-gradient(to right, rgba(38, 0, 255, 0), rgba(0, 1, 83, 0.99))',
      flex: '1',
    },

    yourFail: {
      color: 'red',
      // backgroundColor: 'rgba(32,0,32,0.7)',
      fontSize: '1.2em',
      paddingLeft: '5px',
    },

    notYet: {
      color: "lightgreen",
      fontSize: '2em',
    },

    link: {
      // color: theme.text,
      color: 'white',
      fontSize: 42,
      fontWeight: 'bold',
      textAlign: 'center',
      backgroundColor: 'rgba(16,0,16,0.7)',
      textDecorationLine: 'underline',
    },
    button: {
      height: 40,
      borderRadius: 5,
      padding: 6,
      // backgroundColor: theme.button,
      backgroundColor: 'darkblue',
      justifyContent: 'center',
    },
    butttonText: {
      // color: theme.text,
      color: 'white',
      fontSize: 16,
      fontWeight: 'bold',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: 4,
    },
    icon: {
      // color: theme.text,
      color: 'white',
      fontSize: 36,
      // backgroundColor: theme.background,
      backgroundColor: 'black',
      textAlign: 'right',
      verticalAlign: 'middle',
      padding: 1,
      width: '10%'
    },
    viewrow: {
      flexDirection: 'row',
      width: '100%',
    },
    row: {
      height: '100',
      width: '100%',
      flexDirection: 'row',
      marginBottom: 2,
      backgroundColor: 'rgba(16,0,16,0.7)',
      // borderColor: 'white',
      // borderWidth: 2,
      // borderStyle: 'solid',
      // borderRadius: 5,
    },
    row2: {
      height: '100',
      width: '100%',
      flexDirection: 'row',
      backgroundColor: 'black',
      marginBottom: 2,
    },
    sep: {
      height: 3,
      backgroundColor: 'gray',
      width: '50%',
      maxWidth: 400,
      marginHorizontal: 'auto',
      marginBottom: 2,
    },
    image: {
      height: '100%',
      width: 'auto',
      flex: 1,
      justifyContent: 'center',
    }
  })
}

/*
                  ApptState:{JSON.stringify(apptState)}<br></br>
                  rem24:{JSON.stringify(rem24)}<br></br>
                  remDay:{JSON.stringify(remDay)}<br></br>

*/

